module.exports = __webpack_public_path__ + "static/media/highlight-alt.51d8477e.svg";